export type LanguageCode = 'de' | 'en';

// Language interface
export interface Language {
  code: LanguageCode;
  name: string;
  icon?: string; // Optional icon identifier
  isDefault?: boolean; // Is this the default language
}

// Available languages in the application
export const AVAILABLE_LANGUAGES: Language[] = [
  { code: 'de', name: 'Deutsch', icon: 'flag', isDefault: true },
  { code: 'en', name: 'English', icon: 'language' },
];

// Utility function to get a language by code
export function getLanguageByCode(code: LanguageCode): Language {
  return (
    AVAILABLE_LANGUAGES.find((lang) => lang.code === code) ||
    AVAILABLE_LANGUAGES.find((lang) => lang.isDefault) ||
    AVAILABLE_LANGUAGES[0]
  );
}

// Utility function to get default language
export function getDefaultLanguage(): Language {
  return (
    AVAILABLE_LANGUAGES.find((lang) => lang.isDefault) || AVAILABLE_LANGUAGES[0]
  );
}
